"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _Service_instances, _Service_serviceName, _Service_getUri, _Service_fetch;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Service = void 0;
const querystring_1 = __importDefault(require("querystring"));
const axios_1 = __importDefault(require("axios"));
const OneMap_1 = require("../OneMap");
class Service {
    constructor(onemap, serviceName) {
        _Service_instances.add(this);
        _Service_serviceName.set(this, void 0);
        this.onemap = onemap;
        __classPrivateFieldSet(this, _Service_serviceName, serviceName, "f");
    }
    commonapi(endpoint, query) {
        return __awaiter(this, void 0, void 0, function* () {
            return __classPrivateFieldGet(this, _Service_instances, "m", _Service_fetch).call(this, 'commonapi', endpoint, query);
        });
    }
    privateapi(endpoint, query) {
        return __awaiter(this, void 0, void 0, function* () {
            const auth = yield this.onemap.auth.getToken();
            if (query) {
                query.token = auth.access_token;
            }
            else {
                query = { token: auth.access_token };
            }
            return __classPrivateFieldGet(this, _Service_instances, "m", _Service_fetch).call(this, 'privateapi', endpoint, query);
        });
    }
    getCommonApiUri(endpoint, query) {
        return __classPrivateFieldGet(this, _Service_instances, "m", _Service_getUri).call(this, 'commonapi', endpoint, query);
    }
}
exports.Service = Service;
_Service_serviceName = new WeakMap(), _Service_instances = new WeakSet(), _Service_getUri = function _Service_getUri(type, endpoint, query) {
    if (query) {
        for (const key in query) {
            if (typeof query[key] === 'boolean') {
                query[key] = query[key] ? 'Y' : 'N';
            }
        }
        endpoint += `?${querystring_1.default.stringify(query)}`;
    }
    return `${OneMap_1.OneMap.BASE_URL}/${type}/${__classPrivateFieldGet(this, _Service_serviceName, "f")}/${endpoint}`;
}, _Service_fetch = function _Service_fetch(type, endpoint, query) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const uri = __classPrivateFieldGet(this, _Service_instances, "m", _Service_getUri).call(this, type, endpoint, query);
        const response = yield (0, axios_1.default)(uri, {
            proxy: (_a = this.onemap.options) === null || _a === void 0 ? void 0 : _a.proxy,
            method: 'GET'
        });
        return response.data;
    });
};
